// Internal attributes are pre-computed (at the end of discovery) and stored in `vAttribute` collection.
// They can be overwritten by setting global/local attributes with the following names.
export const ROUTING_DOMAIN_ATTRIBUTE_NAME = 'routingDomain';
export const SITE_NAME_ATTRIBUTE_NAME = 'siteName';
export const STP_DOMAIN_ATTRIBUTE_NAME = 'stpDomain';
export const internalAttributeNames = [
  ROUTING_DOMAIN_ATTRIBUTE_NAME,
  SITE_NAME_ATTRIBUTE_NAME,
  STP_DOMAIN_ATTRIBUTE_NAME,
] as const;
// Fallback site name assigned to constructs not placed into any site by site separation.
export const UNKNOWN_SITE_NAME = 'unknown';
export type InternalAttributeName = (typeof internalAttributeNames)[number];

const internalAttributeNameSet = new Set<string>(internalAttributeNames);

export const isInternalAttributeName = (
  name: string,
): name is InternalAttributeName => internalAttributeNameSet.has(name);
